import _ from 'lodash'

function formatAddress(address) {
  const addressLine = _.join(_.get(address, 'addressLine', []), ', ')
  const cityName = _.get(address, 'cityName')
    ? `, ${_.get(address, 'cityName')}`
    : ''
  const postalCode = _.get(address, 'postalCode')
    ? ` ${_.get(address, 'postalCode')}`
    : ''
  return `${addressLine}${cityName}${postalCode}`
}

export function formatAccommodations(accommodations) {
  return _.reduce(
    accommodations,
    (accommodationsMap, accommodation) => {
      return {
        ...accommodationsMap,
        [`${_.get(accommodation, 'id')}`]: {
          ..._.omit(accommodation, ['@id', '@type']),
          address:
            !_.isEmpty(accommodation.address) &&
            formatAddress(accommodation.address),
          featuredOnItinerary: _.get(accommodation, 'viewExtensions.itineraryFlag'),
        },
      }
    },
    {}
  )
}

export function formatDestinations(destinations) {
  const filteredDestinations = _.filter(destinations, (destination) =>
    _.get(destination, 'published')
  )
  return _.reduce(
    filteredDestinations,
    (destinationMap, destination) => {
      return {
        ...destinationMap,
        [`${_.get(destination, 'id')}`]: {
          accommodations: _.get(destination, 'accommodations', []),
          name: _.get(destination, 'name'),
        },
      }
    },
    {}
  )
}

export function formatTrains(trains) {
  return _.reduce(
    trains,
    (trainsMap, train) => ({
      ...trainsMap,
      [`${_.get(train, 'id')}`]: {
        id: _.get(train, 'id'),
        amenities: {
          ...(_.get(train, 'accommodations') && {
            accommodations: _.get(train, 'accommodations'),
          }),
          ...(_.get(train, 'checkin') && { checkIn: _.get(train, 'checkin') }),
          ...(_.get(train, 'dining') && { dining: _.get(train, 'dining') }),
          ...(_.get(train, 'luggage') && { luggage: _.get(train, 'luggage') }),
          ...(_.get(train, 'notableScenery') && {
            notableScenery: _.get(train, 'notableScenery'),
          }),
        },
        description: _.get(train, 'hero.description'),
        images: _.get(train, 'images'),
        link: _.get(train, 'link'),
        thumbnail: _.get(train, 'thumbnail') || _.get(train, 'images[0]'),
        title: _.get(train, 'title'),
      },
    }),
    {}
  )
}

export function htmlDecode(input) {
  let e = document.createElement('div')
  e.innerHTML = input
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
}

export function removeEscapeHTML(content) {
  return content
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/(<(.*?)>|&\w+;)/g, '')
  //.replace(/\n/g, '<br />');
}
